export const DAO_CODE = 'VEHICLE' + 'TYPES' + '_DAO';
